<div class="leads-details-pa">
  <div class="info-section">
    <h2 class="section-title">Informações do Lead</h2>
    <div class="section-divider"></div>

    <app-info-field [data]="leadInfo['linha1'] || []" [columns]="8" />
    <div class="spacer" style="height: 2rem"></div>
    <app-info-field [data]="leadInfo['linha2'] || []" [columns]="8" />
    <div class="spacer" style="height: 2rem"></div>
    <app-info-field [data]="leadInfo['linha3'] || []" [columns]="8" />
  </div>

  <div class="info-section">
    <h2 class="section-title">Informações do Financiamento</h2>
    <div class="section-divider"></div>
    <div class="financing-info">
      <app-info-field [data]="financingInfo['linha1'] || []" [columns]="6" />
      <div class="spacer" style="height: 4rem"></div>
      <app-info-field [data]="financingInfo['linha2'] || []" [columns]="6" />
      <div class="spacer" style="height: 4rem"></div>
      <app-info-field [data]="financingInfo['linha3'] || []" [columns]="6" />
    </div>
  </div>

  <div class="new-simulation-button-container">
    <button class="nav-btn" (click)="navigate.emit(1)" appTrackClick trackEvent="detalhes_oferta"
      trackCategory="lead_details" trackLabel="button_navigation">
      Detalhes da Oferta
    </button>
    <button class="nav-btn" (click)="navigate.emit(2)" appTrackClick trackEvent="historico"
      trackCategory="lead_details" trackLabel="button_navigation">
      Histórico
    </button>
    <button class="new-simulation-button" (click)="generateSimulation.emit()" appTrackClick
      trackEvent="nova_simulacao" trackCategory="lead_details" trackLabel="generate_simulation">
      Gerar Nova Simulação
    </button>
  </div>
</div>
